// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"99":"805d74f0","131":"94c0e446","603":"765b2f33","783":"c5fc978a"}[chunkId] + ".css";
};